import React from "react";
import { generateBreadcrumbSchema } from "./breadcrumb.utils";
import { serializeJsonLd } from "@/lib/jsonLd";

/**
 * Server-renderable JSON-LD Structured Data Schema Component for Breadcrumbs
 * @param {object} props
 * @param {Array} props.items - Array of formatted breadcrumb objects
 * @param {string} [props.baseURL] - Production target base URL
 */
export default function BreadcrumbSchema({ items, baseURL = "https://tykkit.com" }) {
  if (!items || items.length === 0) {
    return null;
  }

  const schema = generateBreadcrumbSchema(items, baseURL);

  return (
    <script
      type="application/ld+json"
      id="breadcrumbs-jsonld"
      dangerouslySetInnerHTML={{
        __html: serializeJsonLd(schema),
      }}
    />
  );
}
